module.exports = __webpack_public_path__ + "static/avatar_konstantin_malasaev@2x-9daff191fb239bcbebfb2d89011053b2.jpg";